import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import Basic from './Basic';
import Directions from './Direction';
import HtmlContents from './HtmlConten';
import Offset from './Offset';

const PopOversContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Popover' parent='Ui Kits' title='Popover' />
      <Row className='popover-main'>
        <Basic />
        <Directions />
        <HtmlContents />
        <Offset />
      </Row>
    </Container>
  );
};
export default PopOversContainer;
